import { tw } from "@careinfo/tailwind";
import PhoneNumberField from "../Reusable/PhoneNumberField";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { validateParty } from "../../utils/validationSchemas";
import Button from "../Reusable/Button";
import Card from "../Reusable/Card";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/EndPoint";
import LocalCombobox from "../Reusable/AccountCombobox";
import TextField from "../Reusable/AccountTextField";
import UnControlSwitch from "../Reusable/UnControlSwitch";
import { useState } from "react";
import useGetHook from "../../customHooks/useGetHook";

const AccountingIntegration = (props: any) => {
  const { profile } = props;
  console.log("profile in accounting integration", profile);
  const {
    data: merchantAccount,
    isLoading: isCurrentClientLoading,
    refetch,
  } = useGetHook({
    queryKey: [`party-${profile?.user_info?.id}`],
    url: `${APIS.CREATE_ACCOUNT_PARTY}party-by-user/`,
    params: {
      user: profile?.user_info?.id,
    },
  });
  console.log("merchantAccount", merchantAccount);
  const accountData = [
    {
      id: "d4e5f6a7-8b9c-4d1e-2f3a-5b6c7d8e9f0a",
      name: "Sundry Creditors",
    },
    {
      id: "a17de76c-e2bf-4db1-9fbb-908002c43473",
      name: "Sundry Debtors",
    },
  ];

  const Type = [
    {
      id: "cusstomer",
      name: "Customer",
    },
    {
      id: "supplier",
      name: "Supplier",
    },
    {
      id: "both",
      name: "Both",
    },
  ];
  const {
    control,
    register,
    setValue,
    getValues,
    clearErrors,
    formState: { errors },
    handleSubmit,
    setError,
    watch,
  } = useForm<any>({
    resolver: yupResolver(validateParty),
    defaultValues: {
      account: accountData[1],
      full_name: profile?.name || profile?.full_name || "N/A",
      vat_pan: profile?.vat_pan || "N/A",
      address: profile?.user_info?.address || "",
      mobile_number: profile?.user_info?.mobile_number || "",
      email: profile?.user_info?.email || profile?.email || "",
      type: Type[0],
    },
  });
  console.log("default values", { ...getValues() });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["customer-info"],
    // navigateURL: "/accounting/customer",
  });
  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.CREATE_ACCOUNT_PARTY;
    const formData = {
      ...values,
      role: values?.type?.id,
      user: profile?.user_info?.id,
      is_supplier: false,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        refetch();
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleCreate(data, setError))}
          autoComplete="off"
        >
          <div className={tw`grid grid-cols-2 gap-x-2 px-4`}>
            <LocalCombobox
              data={accountData}
              errors={errors?.account}
              setValue={setValue}
              register={register("account")}
              name={"account"}
              clearErrors={clearErrors}
              value={watch("account")}
              label={"Default Account"}
            />
            <TextField
              label="Full Name"
              control={control}
              name={"full_name"}
              placeholder=""
            />
            <TextField
              label="PAN/VAT"
              control={control}
              placeholder=""
              name={"vat_pan"}
            />
            <TextField
              label="Address"
              control={control}
              name={"address"}
              placeholder=""
            />
            <PhoneNumberField
              control={control}
              label={"Mobile Number"}
              name={"mobile_number"}
              errors={errors?.mobile_number}
            />
            <div className={tw`mt-2`}>
              <TextField
                label="Email"
                control={control}
                name={"email"}
                placeholder=""
              />
            </div>
            <LocalCombobox
              data={Type}
              errors={errors?.type}
              setValue={setValue}
              register={register("type")}
              name={"type"}
              clearErrors={clearErrors}
              value={watch("type")}
              label={"Type"}
            />
          </div>
          <div
            className={tw`mt-4 w-full px-2 flex items-center justify-end gap-4`}
          >
            <div>
              <UnControlSwitch
                value={merchantAccount?.id}
                disabled={merchantAccount?.id}
                onChange={handleSubmit((data) => handleCreate(data, setError))}
              />
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AccountingIntegration;
